import localhost from "../../../apis/localhost";
import { showErrorModal } from "../../app/actions/error";
import { addToJobQueue, removeFromJobQueue } from "../../app/appSlice";
import { setSharepointSettings } from "../sharepointSlice";
import { CONNETION_FAILED } from "./constants";

export const fetchSharepointSettings = ({ isCloudMode }) => {
  return async (dispatch) => {
    dispatch(addToJobQueue("fetchSharepointSettings"));

    const url = isCloudMode
      ? "/sharepoint/cloud/settings"
      : "/sharepoint/settings";

    try {
      const { data } = await localhost.get(url);

      if (data) {
        const settings = {
          id: data.id,
          sharepointEnabled: data.sharepointEnabled,
          clientId: data.clientId,
          sharepointUrl: data.sharepointUrl,
          tenantId: data.tenantId,
          siteUrl: data.siteUrl,
          clientSecret: data.clientSecret,
        };

        dispatch(setSharepointSettings(settings));
      }
    } catch (error) {
      const { response } = error;
      const errorMessage = response.data.detail || "Failed to fetch settings";
      dispatch(showErrorModal({ message: errorMessage }, CONNETION_FAILED));
    } finally {
      dispatch(removeFromJobQueue("fetchSharepointSettings"));
    }
  };
};
